import React from 'react';
import './About.css';

import { Heading, Button } from '../../components';
import { images } from '../../constants';

import { TiTick } from 'react-icons/ti';
import ReactPlayer from 'react-player';


const About = () => {
  return (
    <section className='about' id='Nosotros'>

      <Heading title={'sobre nosotros'} span={''} />

      <div className='box-container'>

        <div className='video-container'>
          <ReactPlayer
            url={images.about}
            playing={true}
            loop={true}
            muted={true}
            width='100%'
            height='50rem' />
        </div>

        <div class="content">
          <h2>Nuestra Historia</h2>
          <p>Hace 34 años, en el corazón de un país en constante evolución, nació nuestra empresa S.H.C.C. INGENIARÍA con una misión clara: ofrecer soluciones eléctricas de calidad que impulsaran el desarrollo y bienestar de la comunidad. Desde nuestros inicios, nos hemos especializado en el desarrollo de proyectos eléctricos en baja y media tensión, estableciendo un estándar de excelencia que nos ha permitido crecer y adaptarnos a las demandas del mercado. A lo largo de los años, hemos expandido nuestras capacidades para incluir instrumentación y control industrial, asegurando que nuestros clientes cuenten con tecnología avanzada y sistemas de monitoreo efectivos. Nuestra experiencia también se extiende al mantenimiento de grupos generadores y bombas de agua, lo que nos permite ofrecer un servicio integral y confiable. Hoy en día, somos reconocidos como líderes en el sector eléctrico, con un compromiso constante hacia la innovación, la eficiencia y la sostenibilidad. Nuestros 34 años de trayectoria son un testimonio de nuestra dedicación a la calidad y la satisfacción del cliente, y seguimos trabajando para ser la opción preferida en soluciones eléctricas en el futuro.</p>
          
          <h2>Misión</h2>
          <p>Nuestra misión es proporcionar soluciones eléctricas integrales y de alta calidad en baja y media tensión, así como en instrumentación y control industrial. Nos comprometemos a ofrecer un servicio excepcional en la instalación y mantenimiento de grupos generadores y bombas de agua potable, aguas servidas y de pozo profundo, garantizando la satisfacción del cliente a través de la innovación, la eficiencia y el cumplimiento de las normativas de seguridad.</p>

          <h2>Visión</h2>
          <p>Nuestra visión es ser líderes en el sector eléctrico, reconocidos por nuestra excelencia en el desarrollo de proyectos y soluciones energéticas sostenibles. Aspiramos a impulsar el progreso de nuestras comunidades y clientes mediante tecnologías innovadoras y un enfoque en la eficiencia energética, contribuyendo así a un futuro más sostenible y responsable.</p>

          <Button link={'contacto'} title={'contáctanos'} />
        </div>

      </div>

    </section>
  )
}

export default About;
